import React, { useState, useCallback, useEffect } from 'react';
import { useMutation } from '@apollo/client';
import { CREATE_LINKED_ATTACHMENT } from '../queries';
import { ContentContainer } from '../../../elements';
import { View, Text } from 'react-native';
import {
  LinkedAttachmentContainer,
  LinkedAttachmentInnerContainer,
  LinkedAttachmentTitle
} from '../elements';
import { ButtonGroup, Button, ButtonContainer } from '../../../elements/buttons';
import { useForm } from 'react-hook-form';
import Input from '../../../elements/inputs';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCirclePlus, faCircleXmark } from '@fortawesome/free-solid-svg-icons';
import * as colors from '../../../styles/colors';

const EditLinkedAttachment = (props) => {
  const {
    linkedAttachment,
    linkedAttachments,
    setShowModal,
    setValue,
    resourceType,
    resourceId,
    multi
  } = props;
  const [submitting, setSubmitting] = useState(false);
  const [linkedFiles, setLinkedFiles] = useState();
  const [saveLinkedAttachment] = useMutation(CREATE_LINKED_ATTACHMENT,
    {
      onCompleted(response) {
        setShowModal(false);
        // updateAttachments(
        //   attachmentType,
        //   'add',
        //   response.uploadAttachment.attachment
        // )
      }
    }
  );

  const onSubmit = useCallback(input => {
    setSubmitting(true);
  });

  const {
    control, register, handleSubmit, watch, formState: { errors }
  } = useForm({
    defaultValues: {
      name: linkedAttachment?.name || '',
      url: linkedAttachment?.url || ''
    }
  });

  const watchName = watch('name');
  const watchUrl = watch('url');

  useEffect(() => {
    if(watchName.length && watchUrl.length) {
      if(!multi) {
        setValue('linkedAttachment', {
          id: linkedAttachment?.id,
          name: watchName,
          url: watchUrl,
          resourceId: resourceId,
          resourceType: resourceType
        })
      }
    }
  }, [watchName, watchUrl]);

  const addMulti = () => {
    let newAttachments = linkedAttachments;
    let addNew = true;
    for(let x = 0; x < newAttachments?.length; x++ ) {
      if(newAttachments[x].url === watchUrl &&
        newAttachments[x].name === watchName
      ) {
        addNew = false;
        break;
      }
    }
    if(addNew) {
      newAttachments = [...newAttachments,
        {
          name: watchName,
          url: watchUrl,
          resourceId: resourceId,
          resourceType: resourceType
        }
      ];
      setValue(newAttachments)
    }
  }

  const removeAttachment = (attachmentToRemove) => {
    let newAttachments = linkedAttachments.filter(attachment =>
      attachment !== attachmentToRemove
    );
    setValue(newAttachments);
  }

  return (
    <LinkedAttachmentContainer>
      <LinkedAttachmentTitle>Linked Attachment:</LinkedAttachmentTitle>
      <LinkedAttachmentInnerContainer>
        <Input.Text
          label="Name:"
          name="name"
          control={control}
          errors={errors}
        />
        <Input.Text
          label="URL:"
          name="url"
          control={control}
          errors={errors}
        />
        {multi &&
          <FontAwesomeIcon
            icon={faCirclePlus}
            size='2xl'
            style={{color: colors.elRed}}
            onClick={() => addMulti()}
          />
        }
        {linkedAttachments &&
          <View>
            <b>Linked Files:</b>
            {linkedAttachments.map(attachment => {
              return (
                <View style={{
                  display: 'flex', flexDirection: 'row', marginBottom: '10px'
                }}>
                  <Text>
                    {`${attachment.name} ${!attachment.id ? '(Not Saved)' : ''}`}
                  </Text>
                  <FontAwesomeIcon
                    icon={faCircleXmark}
                    size='sm'
                    style={{color: colors.elRed, marginTop: '2px'}}
                    onClick={() => removeAttachment(attachment)}
                  />
                </View>
              )
            })}
          </View>
        }
      </LinkedAttachmentInnerContainer>
    </LinkedAttachmentContainer>
  )
}

export default EditLinkedAttachment;
